import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/spring/init', method: 'GET', params }, { interceptResultCode: false });
}

// 抽奖
export const lotteryDataAPI = (params) => {
  return axios({ url: '/snail/spring/draw', method: 'POST', params }, { interceptResultCode: false });
}

// 任务
export const taskDataAPI = (params) => {
  return axios({ url: '/snail/spring/task', method: 'GET', params }, { interceptResultCode: false });
}

// 彩蛋中的cdk
export const eggRewardDataAPI = (params) => {
  return axios({ url: '/snail/spring/cdk/receive', method: 'POST', params }, { interceptResultCode: false });
}

// 协助
export const assistanceDataAPI = (params) => {
  return axios({ url: '/snail/spring/assistance', method: 'GET', params }, { interceptResultCode: false });
}

// 下载
export const downloadApps = (params) => {
  return axios( { url: "/jump/download/url", method: "POST", params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/snail/nyf/api.js